import React from 'react';
import { Input, Button, PaperClip, Select, Modal } from 'components';
import { ServiceService } from 'services';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants } from 'utils';
import { Download2Icon } from 'assets/icons';
import { UploadServiceImage } from 'assets/img';
import { connect } from 'react-redux';
import ModalServices from './modal-services';

interface Props extends RootState {
	onClose?: any;
}

class ModalUpload extends React.Component<Props> {

	state = {
		form: {
			file: ''
		},
		open_services: false
	}

	submit = async (e: any) => {
		e.preventDefault();

		if (!this.state.form.file) {
			Globals.showError("Debe subir el archivo para continuar");
			return;
		}

		await ServiceService.doctor.upload({
			user_id: this.props.user?.id,
			hasFile: true,
			// @ts-ignore,
			file: this.state.form.file?.value || '',
		});
		Globals.showSuccess("Se ha subido el formato correctamente");
		this.props.onClose();
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	openServices = () => {
		this.setState({
			open_services: true
		});
	}

	onCloseServices = () => {
		this.setState({
			open_services: false
		});
	}
	
	render() {
		const { open_services } = this.state;

		return (
			<div id="modal-service-upload">
				<Modal
		          className="modal-list-services"
		          visible={ open_services }
		          withoutClose={ true }
		          onClose={ () => this.onCloseServices() }
		        >
		          <ModalServices
		            onClose={ () => this.onCloseServices() } />
		      	</Modal>

				<form onSubmit={ this.submit }>
					<div className="row">
						<div className="col-md-4 container-bg">
							<img src={ UploadServiceImage } />
						</div>
						<div className="col-md-8">
							<div className="container-form">
								<h3>Registro Masivo de Servicios</h3>
								<p><strong>Paso 1 -</strong> Descargue archivo de excel</p>
								<Button className="btn-download" type="button" onClick={ () => {
									window.open(Constants.BASE_PUBLIC + 'files/upload-services.xlsx','_blank');
								} }>
									<img src={ Download2Icon } />
									Descargar archivo
								</Button>
								<p><strong>Paso 2 -</strong> Identifique los ID de los servicios</p>
									
								<div className="row row-buttons-ids">
									<div className="col-md-6">
										<Button className="btn-download" type="button" onClick={ () => this.openServices() }>
											ID de servicios
										</Button>
									</div>
								</div>

								<p><strong>Paso 3 -</strong> Cargue la información de sus servicios, en el orden indicado en el archivo excel. No olvide los datos obligatorios</p>
								<p><strong>Paso 4 -</strong> Suba su archivo excel con la información de sus servicios</p>

								<PaperClip
									formats={['xlsx']}
									value={ this.state.form.file }
									onChange={ (e: any) => {
										this.setState({
											form: {
												...this.state.form,
												file: e.target
											}
										})
									} }>
								</PaperClip>

								<div className="row row-buttons">
									<div className="col-md-6 text-center">
										<Button type="button" className="btn-close" onClick={ () => this.props.onClose() }>
											Cerrar
										</Button>
									</div>
									<div className="col-md-6 text-center">
										<Button type="submit">
											Subir Formato
										</Button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</form>
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(ModalUpload);